import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {OG_PATH} from "@/content";

const serviceId = 4
const slug = 'sydney-electrical-fault-finding-and-repairs';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: "Electrical Fault Finding & Repairs",
        description: "Diagnosing and repairing electrical faults to maintain safety and functionality in Sydney.",
        keywords: "ev charger installation, electric vehicle chargers, home ev chargers, business ev charging solutions, sydney ev charger installation",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Electrical Fault Finding & Repairs',
    description: "Diagnosing and repairing electrical faults to maintain safety and functionality in Sydney.",
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
